// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Head_wrapper__3WPXu","sync":"Head_sync__372HN","syncText":"Head_syncText__3cqCw","icon":"Head_icon__2ETC9"};